import React, { useEffect, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { SearchAutosuggest as RSKSearchAutosuggest, SearchStats } from '@uncinc/react-searchkit';
import { SearchAutosuggestProps as Type } from '@uncinc/react-searchkit/dist/components/Autosuggest';

import SearchBar, { SearchBarProps } from '../Bar';

import './style.scss';

export interface SearchAutosuggestProps {
  autosuggestProps: Type;
  searchbarProps?: SearchBarProps;
  type?: 'primary' | 'secondary';
  searchInputRef?: React.RefObject<HTMLInputElement>;
}

const SearchAutosuggest: React.FC<SearchAutosuggestProps> = (props) => {
  const {
    autosuggestProps,
    searchbarProps,
    type,
    searchInputRef,
  } = props;

  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const comboboxContainer = container.querySelector('[role="combobox"]');

    if (!comboboxContainer) return;

    // Remove ALL combobox attributes from container
    // This allows NVDA's "E" key navigation to find the input as an edit field
    // The input retains aria-autocomplete="list" and aria-controls from react-autosuggest
    comboboxContainer.removeAttribute('role');
    comboboxContainer.removeAttribute('aria-haspopup');
    comboboxContainer.removeAttribute('aria-owns');
    comboboxContainer.removeAttribute('aria-expanded');
  }, []);

  const classes = c('SearchAutosuggest', {
    ...(type && { [`SearchAutosuggest--${type}`]: type }),
  });

  return (
    <div className={classes} ref={containerRef}>
      <RSKSearchAutosuggest
        {...autosuggestProps}
        renderInputComponent={(inputProps) => (
          <>
            <SearchBar
              {...inputProps}
              {...searchbarProps}
              type={type}
              ref={searchInputRef}
            />
            <div className="SearchAutosuggest__stats-wrapper">
              <div className="SearchAutosuggest__stats">
                <p>{t('searchkit.autocomplete.title')}</p>
                <SearchStats />
              </div>
            </div>
          </>
        )}
      />
    </div>
  );
};

export default SearchAutosuggest;
